import { useNavigate, useLocation } from 'react-router-dom';

const updateQueryParams = (queryParams: URLSearchParams) => {
  const documentTitle = document.title;
  var urlSplit = window.location.href.split('?');
  const paramString = queryParams.toString();
  var obj = {
    Title: documentTitle,
    Url: urlSplit[0] + (paramString.length > 0 ? `?${paramString}` : ''),
  };
  window.history.pushState(obj, obj.Title, obj.Url);
};

export const useUpdateQueryParams = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (queryParams: URLSearchParams, replace = false) => {
    if (replace) {
      navigate(
        { ...location, search: queryParams.toString() },
        { replace: true },
      );
    } else {
      navigate({ ...location, search: queryParams.toString() });
    }
  };
};

export default updateQueryParams;
